import axios from 'axios'
import config from '../config'

const weatherServer = config.WEATHER_SERVER

const getWreckWeather = async (lat, lon) => {
  const response = await axios.get(`${weatherServer}/forecast?lat=${lat}&lon=${lon}`)
  return response.data
}

export default {
  getWreckWeather,
}
